import "./App.css";
import Home from "./page/Home";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import NoInternet from "./components/NoInternet";
import MobileErrorPage from "./components/MobileErrorPage";
import DisableInspect from "./components/notifyComponents/DisableInspect";
import useSmartTvScreen from "./components/useSmartTvScreen";
 
function App() {
    const isTvScreen = useSmartTvScreen(1000);

  const [status, setStatus] = useState(true);
  useEffect(() => {
    function changeStatus() {
      setStatus(navigator.onLine);
    }
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);
  return (
    <>
      <DisableInspect />
      {status ? (
        <div>{isTvScreen ? <Home /> : <MobileErrorPage />}</div>
      ) : (
        <NoInternet />
      )}
    </>
  );
}

export default App;
